export default __webpack_public_path__ + "static/media/gunahomes_buyers.b05b080a.png";